module.exports = __webpack_public_path__ + "wmportal_login_background.png";